import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-profile-card-modal',
  templateUrl: './profile-card-modal.component.html',
  styleUrls: ['./profile-card-modal.component.scss']
})
export class ProfileCardModalComponent implements OnInit {
  profileCardImg: string = '/workflow-profile-card-en.png';

  constructor(
    private readonly toastrService: ToastrService,
    private readonly clipboardService: ClipboardService,
    private readonly translate: TranslateService,
    private readonly languageService: LanguageService,
    public dialogRef: MatDialogRef<ProfileCardModalComponent>
  ) {}

  ngOnInit(): void {
    const lang = this.languageService.getCurrentLanguage();
    this.profileCardImg = `/workflow-profile-card-${lang}.png`;
  }

  shareProfileCard() {
    const fullUrl = window.location.origin + this.profileCardImg;
    this.clipboardService.copy(fullUrl);
    this.toastrService.success(this.translate.instant('landing.text.link_copied'));
  }
}
